import { Utilities } from "../../../utils/utilities";
import { ReadAccess } from "../General/AccessData";
import { FirebaseData } from "../General/FirebaseData";
import { FirebaseFile } from "../General/FirebaseFile";
import { TranslationData } from "../General/TranslationData";

export class PostData extends FirebaseData {
  title: TranslationData = new TranslationData();
  body: TranslationData = new TranslationData();
  files: FirebaseFile[] = [];

  postDate?: Date = undefined;

  authors: ReadAccess = {};

  readAccess: ReadAccess = {};

  setup(data: any): void {
    this.title.setup(data.title);
    this.body.setup(data.body);
    this.postDate = Utilities.getDateFromTimestamp(data.postDate);

    this.authors = Utilities.getReadAccess(data.authors);
    this.readAccess = Utilities.getReadAccess(data.readAccess);

    this.files = [];
    if (typeof data.files === "object") {
      for (const fileId in data.files) {
        const fileData = data.files[fileId];
        const path = fileData.path;
        const file = new FirebaseFile(path);
        file.id = fileId;
        file.title = fileData.name;
        file.fileType = fileData.type;
        this.files.push(file);
      }
    }
  }
}

